(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    class AccordionAnimated extends HTMLElement {
    constructor() {
      super();
      this.details = null;
      this.summary = null;
      this.mediaQuery = null;
    }

    connectedCallback() {
      try {
        this.initializeElements();
        this.initializeAccessibility();
        this.initializeDefaultState();
        this.setupObservers();
      } catch (error) {
        console.error('Error initializing accordion:', error);
      }
    }

    disconnectedCallback() {
      this.cleanup();
    }

    initializeElements() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');

      if (!this.details || !this.summary) {
        throw new Error('Required elements not found in accordion');
      }
    }

    initializeAccessibility() {
      this.summary.setAttribute('role', 'button');
      this.summary.setAttribute('tabindex', '0');
      
      this.summary.addEventListener('click', () => {
        const isOpen = this.details.hasAttribute('open');
        this.summary.setAttribute('aria-expanded', !isOpen);
        this.details.setAttribute('aria-expanded', !isOpen);
      });
    }

    initializeDefaultState() {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const shouldOpen = (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
                         (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
      
      if (shouldOpen && !this.details.hasAttribute('open')) {
        this.details.setAttribute('open', '');
      }
    }

    setupObservers() {
      this.mediaQuery = window.matchMedia('(max-width: 749px)');
      this.mediaQuery.addEventListener('change', this.handleBreakpointChange.bind(this));
    }

    handleBreakpointChange(e) {
      const shouldOpen = (e.matches && this.hasAttribute('open-by-default-on-mobile')) ||
                         (!e.matches && this.hasAttribute('open-by-default-on-desktop'));
      
      const isCurrentlyOpen = this.details.hasAttribute('open');
      
      if (shouldOpen && !isCurrentlyOpen) {
        this.details.setAttribute('open', '');
      } else if (!shouldOpen && isCurrentlyOpen) {
        this.details.removeAttribute('open');
      }
    }

    cleanup() {
      if (this.mediaQuery) {
        this.mediaQuery.removeEventListener('change', this.handleBreakpointChange.bind(this));
      }
    }

    // API PÚBLICA
    open() {
      this.details.setAttribute('open', '');
    }

    close() {
      this.details.removeAttribute('open');
    }

    toggle() {
      if (this.details.hasAttribute('open')) {
        this.close();
      } else {
        this.open();
      }
    }

    isOpen() {
      return this.details.hasAttribute('open');
    }
  }

  customElements.define('accordion-custom', AccordionAnimated);
  } catch(e) { console.error(e); }
})();

})();
